import {
  Channel3r72atmcithql as Channel,
  ClosedSendChannelException29m33prpq9jaw as ClosedSendChannelException,
  ClosedReceiveChannelException3ofg6gf5f5b38 as ClosedReceiveChannelException,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Job13y4jkazwjho0 as Job,
  Key_instance2rlngjw9v1qsd as Key_instance,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { get_LOGGER1pnacb4n2g1eb as get_LOGGER } from './DefaultWebSocketSession.mjs';
import {
  Pong3m3cas9hmc9ec as Pong,
  Ping3nta6l7sdq1r9 as Ping,
} from './Frame.web.mjs';
import { cancelConsumed2i0oizqhmljf6 as cancelConsumed } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channels.common.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Charsets_getInstanceqkyjyusuh1b0 as Charsets_getInstance } from '../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Charset.js.mjs';
import { toByteArray1i3ns5jnoqlv6 as toByteArray } from '../../../../ktor-ktor-io/io/ktor/utils/io/core/Strings.mjs';
import { decodeToString1dbzcjd620q25 as decodeToString } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { getTimeMillis12o7k17x9fmwi as getTimeMillis } from '../../../../ktor-ktor-utils/io/ktor/util/date/DateJs.mjs';
import { Randomei1bbeye8rr8 as Random } from '../../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
import { withTimeoutOrNull3fn9ef0keo2ht as withTimeoutOrNull } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Timeout.mjs';
import { hex2ofqpe9ngcu1i as hex } from '../../../../ktor-ktor-utils/io/ktor/util/Crypto.mjs';
import {
  CloseReason10cphaqpp3ct7 as CloseReason,
  Codes_INTERNAL_ERROR_getInstance18ad4i9h6oigs as Codes_INTERNAL_ERROR_getInstance,
} from './CloseReason.mjs';
import { ClosedByteChannelException3il8gfpye60w as ClosedByteChannelException } from '../../../../ktor-ktor-io/io/ktor/utils/io/Exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { CoroutineName2g5zosw74tf0f as CoroutineName } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineName.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_PongerCoroutineName() {
  _init_properties_PingPong_kt__9aqxey();
  return PongerCoroutineName;
}
var PongerCoroutineName;
function get_PingerCoroutineName() {
  _init_properties_PingPong_kt__9aqxey();
  return PingerCoroutineName;
}
var PingerCoroutineName;
function ponger(_this__u8e3s4, outgoing) {
  _init_properties_PingPong_kt__9aqxey();
  var channel = Channel(5);
  var tmp = get_PongerCoroutineName();
  launch(_this__u8e3s4, tmp, VOID, ponger$slambda_0(channel, outgoing));
  return channel;
}
function pinger(_this__u8e3s4, outgoing, periodMillis, timeoutMillis, onTimeout) {
  _init_properties_PingPong_kt__9aqxey();
  var actorJob = Job();
  var channel = Channel(2147483647);
  var tmp = actorJob.rm(get_PingerCoroutineName());
  launch(_this__u8e3s4, tmp, VOID, pinger$slambda_0(periodMillis, timeoutMillis, onTimeout, channel, outgoing));
  var tmp_0 = ensureNotNull(_this__u8e3s4.dw().yc(Key_instance));
  tmp_0.gx((it) => {
    actorJob.ox();
    return Unit_instance;
  });
  return channel;
}
var ponger$slambdaClass;
function ponger$slambda() {
  if (ponger$slambdaClass === VOID) {
    class $ {
      constructor($channel, $outgoing) {
        this.f5e_1 = $channel;
        this.g5e_1 = $outgoing;
      }
      *c1g($this$launch, $completion) {
        try {
          // Inline function 'kotlinx.coroutines.channels.consumeEach' call
          var tmp0 = this.f5e_1;
          $l$block: {
            // Inline function 'kotlinx.coroutines.channels.consume' call
            var cause = null;
            try {
              var _iterator__ex2g4s = tmp0.p1();
              while (yield* _iterator__ex2g4s.p1a($completion)) {
                var e = _iterator__ex2g4s.r1();
                get_LOGGER().e4u('Received ping message, sending pong message');
                yield* this.g5e_1.d1b(Pong().o5d(e.v5c_1), $completion);
              }
              break $l$block;
            } catch ($p) {
              if ($p instanceof Error) {
                var e_0 = $p;
                cause = e_0;
                throw e_0;
              } else {
                throw $p;
              }
            }
            finally {
              cancelConsumed(tmp0, cause);
            }
          }
        } catch ($p) {
          if ($p instanceof ClosedSendChannelException()) {
            var _unused_var__etf5q3 = $p;
          } else {
            throw $p;
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ponger$slambdaClass = $;
  }
  return ponger$slambdaClass;
}
function ponger$slambda_0($channel, $outgoing) {
  var i = new (ponger$slambda())($channel, $outgoing);
  var l = ($this$launch, $completion) => i.c1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var pinger$slambda$slambdaClass;
function pinger$slambda$slambda() {
  if (pinger$slambda$slambdaClass === VOID) {
    class $ {
      constructor($channel) {
        this.h5e_1 = $channel;
      }
      *c1g($this$withTimeoutOrNull, $completion) {
        while (true) {
          yield* this.h5e_1.h1b($completion);
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    pinger$slambda$slambdaClass = $;
  }
  return pinger$slambda$slambdaClass;
}
function pinger$slambda$slambda_0($channel) {
  var i = new (pinger$slambda$slambda())($channel);
  var l = ($this$withTimeoutOrNull, $completion) => i.c1g($this$withTimeoutOrNull, $completion);
  l.$arity = 1;
  return l;
}
var pinger$slambda$slambdaClass_0;
function pinger$slambda$slambda_1() {
  if (pinger$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($outgoing, $pingMessage, $channel) {
        this.i5e_1 = $outgoing;
        this.j5e_1 = $pingMessage;
        this.k5e_1 = $channel;
      }
      *c1g($this$withTimeoutOrNull, $completion) {
        get_LOGGER().e4u('WebSocket Pinger: sending ping frame');
        yield* this.i5e_1.d1b(Ping().s5e(toByteArray(this.j5e_1, Charsets_getInstance().i4m_1)), $completion);
        $l$loop: while (true) {
          var msg = yield* this.k5e_1.h1b($completion);
          if (decodeToString(msg.v5c_1, 0, 0 + msg.v5c_1.length | 0) === this.j5e_1) {
            get_LOGGER().e4u('WebSocket Pinger: received valid pong frame ' + msg.toString());
            break $l$loop;
          }
          get_LOGGER().e4u('WebSocket Pinger: received invalid pong frame ' + msg.toString() + ', continue waiting');
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    pinger$slambda$slambdaClass_0 = $;
  }
  return pinger$slambda$slambdaClass_0;
}
function pinger$slambda$slambda_2($outgoing, $pingMessage, $channel) {
  var i = new (pinger$slambda$slambda_1())($outgoing, $pingMessage, $channel);
  var l = ($this$withTimeoutOrNull, $completion) => i.c1g($this$withTimeoutOrNull, $completion);
  l.$arity = 1;
  return l;
}
var pinger$slambdaClass;
function pinger$slambda() {
  if (pinger$slambdaClass === VOID) {
    class $ {
      constructor($periodMillis, $timeoutMillis, $onTimeout, $channel, $outgoing) {
        this.t5e_1 = $periodMillis;
        this.u5e_1 = $timeoutMillis;
        this.v5e_1 = $onTimeout;
        this.w5e_1 = $channel;
        this.x5e_1 = $outgoing;
      }
      *c1g($this$launch, $completion) {
        get_LOGGER().e4u('Starting WebSocket pinger coroutine with period ' + this.t5e_1.toString() + ' ms and timeout ' + this.u5e_1.toString() + ' ms');
        var random = Random(getTimeMillis());
        var pingIdBytes = new Int8Array(32);
        try {
          $l$loop: while (true) {
            yield* withTimeoutOrNull(this.t5e_1, pinger$slambda$slambda_0(this.w5e_1), $completion);
            random.lo(pingIdBytes);
            var pingMessage = '[ping ' + hex(pingIdBytes) + ' ping]';
            var rc = yield* withTimeoutOrNull(this.u5e_1, pinger$slambda$slambda_2(this.x5e_1, pingMessage, this.w5e_1), $completion);
            if (rc == null) {
              get_LOGGER().e4u('WebSocket pinger has timed out');
              yield* this.v5e_1(CloseReason().l5b(Codes_INTERNAL_ERROR_getInstance(), 'Ping timeout'), $completion);
              break $l$loop;
            }
          }
        } catch ($p) {
          if ($p instanceof CancellationException()) {
            var ignore = $p;
          } else {
            if ($p instanceof ClosedReceiveChannelException()) {
              var ignore_0 = $p;
            } else {
              if ($p instanceof ClosedSendChannelException()) {
                var ignore_1 = $p;
              } else {
                if ($p instanceof ClosedByteChannelException()) {
                  var ignore_2 = $p;
                } else {
                  throw $p;
                }
              }
            }
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    pinger$slambdaClass = $;
  }
  return pinger$slambdaClass;
}
function pinger$slambda_0($periodMillis, $timeoutMillis, $onTimeout, $channel, $outgoing) {
  var i = new (pinger$slambda())($periodMillis, $timeoutMillis, $onTimeout, $channel, $outgoing);
  var l = ($this$launch, $completion) => i.c1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var properties_initialized_PingPong_kt_fbfhmc;
function _init_properties_PingPong_kt__9aqxey() {
  if (!properties_initialized_PingPong_kt_fbfhmc) {
    properties_initialized_PingPong_kt_fbfhmc = true;
    PongerCoroutineName = new (CoroutineName())('ws-ponger');
    PingerCoroutineName = new (CoroutineName())('ws-pinger');
  }
}
//region block: exports
export {
  pinger as pingerd16zvjbf6m9o,
  ponger as ponger270tezdl2mu68,
};
//endregion

//# sourceMappingURL=PingPong.mjs.map
